import { StoreActionType as Type } from "../../types";

type LogState = {
    data: any,
    loading: boolean,
    error: any,
}

const initialState: LogState = {
    data : [], 
    loading: false,
    error: null,
}

export const logsReducer = (state : any = initialState, action : any) => {
    switch (action.type) {
        case Type.GET_CAMPAIGN_LOG_ACTIVITIES_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Type.GET_CAMPAIGN_LOG_ACTIVITIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case Type.GET_CAMPAIGN_LOG_ACTIVITIES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}